import { Component, OnDestroy, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AbstractModalContentComponent } from '../../common/modal/abstract-modal-content.component';
import { ModalService } from '../../common/modal/modal.indra.service';
import * as OptionsBarActions from '@ibe/store/actions/options-bar.actions';
import * as fromStore from '../../../store';
import { Store } from '@ngrx/store';
import * as FlightsFilterActions from '@ibe/store/actions/flights-filter.actions';
import scrollLock from 'scroll-lock';
import { INDRAApiService } from '@ibe.services/api.indra.service';
import { SidebarService } from '@ibe.components/common/sidebar/sidebar.service';
import { INDRAStorageService } from '@ibe.services/storage.indra.service';
import * as UserActions from '@ibe/store/actions/user.actions';
// import * as ModalActions from '@ibe/store/actions/modal.actions';
// import { Observable } from 'rxjs';
// import { takeWhile } from 'rxjs/operators';
import * as DeepLinkPriceMismatchActions from '@ibe/store/actions/deeplink-price-mismatch.actions';

@Component({
	selector: 'app-session-timeout-modal',
	templateUrl: './session-timeout-modal.indra.component.html',
	styleUrls: ['./session-timeout-modal.component.scss']
})
export class INDRASessionTimeoutModalComponent extends AbstractModalContentComponent implements OnInit, OnDestroy {
	htmlElement = document.getElementsByTagName('html');

	// Corp
	// isCorporate$: Observable<boolean> = this.store.select(fromStore.getIsCorporate);
	// isCorporate: boolean;
	// isAlive: boolean = true;
	
	constructor(
		protected modalService: ModalService,
		private route: ActivatedRoute,
		private router: Router,
		protected sidebarService: SidebarService,
		private store: Store<fromStore.State>,
		private api: INDRAApiService,
		private storageService: INDRAStorageService,
		) {
		super(modalService);
		this.TYPE = 'dialog';
		this.CLOSABLE = false; // removed in post-sprint 8 client code delivery
		// this.store.dispatch(new ModalActions.PutShowCloseAction(false));
		
		/*
		this.isCorporate$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				this.isCorporate = value;
			});
		*/
	}
	
	ngOnDestroy() {
		// this.isAlive = false;
	}

	ngOnInit() {
		this.store.dispatch(new DeepLinkPriceMismatchActions.ResetAction());
	}

	INDRA_goToBookingsList() {
		this.modalService.close();
		this.router.navigate(['my-bookings']);
	}


	closeModal() {
		if (this.htmlElement[0].classList.contains('no-scroll')) {
			if (this.router.url.indexOf('sidebar') < 0) {
				this.htmlElement[0].classList.remove('no-scroll');
				scrollLock.show();
			}
		}
		this.modalService.close();
	}

	INDRA_confirm() {
		/* 
		// TODO check if these changes needs to be applied (from Sprint 8 merge)
		if (this.router.url.indexOf('sidebar') >= 0) {
			this.sidebarService.close();
		}
		this.store.dispatch(new OptionsBarActions.PutPriceUnit('cash'));
		this.store.dispatch(new FlightsFilterActions.PutBookAwardFlights(false));
		this.closeModal();
		this.sidebarService.isOpen.subscribe(value => {
			if (value === false) {
				if (this.isCorporate === true)
					this.router.navigate(['/corporate'], { relativeTo: this.route });
				else
					this.router.navigate(['/'], { relativeTo: this.route });
			}
		});
		*/
		this.closeModal();
		this.store.dispatch(new OptionsBarActions.PutPriceUnit('cash'));
		this.store.dispatch(new FlightsFilterActions.PutBookAwardFlights(false));
		this.api.INDRA_createNewSession();
		this.sidebarService.closeSidebar();
		this.storageService.set('allow_navigate', 'true');
		this.INDRA_handleLogout();

		if (this.router.url !== '/booking') {
			this.api.hasToken.subscribe(res => {
				if (res) {
					this.router.navigateByUrl('/booking');
				}
			});

		} else {
			window.location.reload();
		}
	}

	INDRA_handleLogout() {
		this.store.dispatch(new UserActions.PutLoggedInAction(false));
		this.store.dispatch(new UserActions.PutUserInfoAction(false));
		this.store.dispatch(new UserActions.PutCancelLogIn(false));

		this.storageService.remove('userData');
		this.storageService.remove('user_info');
		this.storageService.remove('prevSelectedLanguage');
	}
}



